import { render, staticRenderFns } from "./job-status.vue?vue&type=template&id=2f0c2146&scoped=true&"
import script from "./job-status.component.ts?vue&type=script&lang=ts&"
export * from "./job-status.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0c2146",
  null
  
)

export default component.exports